import * as yup from 'yup';

export const IndividualSalariesTemplateSchema = yup.object().shape({
    salaryStart: yup.date()
      .required('Salary Start Date is required')
      .typeError('Salary Start Date is not a valid date'),
    salaryEnd: yup.date()
      .required('Salary End Date is required')
      .typeError('Salary End Date is not a valid date')
      .min(yup.ref('salaryStart'), 'Salary End Date must be greater than or equal to Salary Start Date'),
  });
